module.exports = __webpack_public_path__ + "static/media/ic_catering.614cdc91.svg";